import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';

export interface IFormulaireProps {
    valueSousModuleDroit: any;
    setValueSousModuleDroit: any;
}

const Formulaire = (props: IFormulaireProps) => {


    const {
        valueSousModuleDroit,
        setValueSousModuleDroit
    } = props


    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Sous module"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueSousModuleDroit"
                        value={valueSousModuleDroit}
                        onChange={(e) => setValueSousModuleDroit(e.target.value)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
export default Formulaire;
